// extracted by mini-css-extract-plugin
export default {"container":"cP0xO95r6","invoiceContainer":"c_cebKXrX","additionalInfo":"cEF_pBgl_","mainContainer":"cXCkRP14B","inPage":"cSjfgN4NN","inBigCart":"cGzMp1I8s"};